import { useState } from 'react';

function useFooterButtonRenderer(): [JSX.Element | null, any] {
    const [footer, setFooter] = useState<JSX.Element | null>(null);

    return [footer, setFooter];
}

export default useFooterButtonRenderer;
